import React from 'react';
import { ArrowLeftRightIcon, CarIcon, HandHeartIcon, VoteIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { DEMO_DATE } from '../../data/demo';
import { isDoneStatus } from '../../utils/progress';
import { isDueOn } from '../../utils/today';
import { formatShortDay } from '../../utils/time';
import { EmptyNote } from '../ui/Panel';
export function OpenAgreements() {
  const {
    family,
    familyOcc,
    db,
    memberById
  } = useAppState();
  const {
    setTab
  } = useUi();
  const offers = family.templates.filter(t => familyOcc[t.id]?.offer && !familyOcc[t.id]?.takenBy);
  const care = family.modules.zivali ? family.templates.filter(t => t.assigneeIds.length === 0 && isDueOn(t, DEMO_DATE) && !isDoneStatus(familyOcc[t.id]?.status) && familyOcc[t.id]?.status !== 'v_pregledu') : [];
  const rides = family.events.filter(e => e.needsDriver && !e.driverId && e.date >= DEMO_DATE);
  const polls = db.polls.filter(p => p.familyId === family.id && p.open);
  const rows = [...offers.map(t => ({
    key: `o-${t.id}`,
    icon: ArrowLeftRightIcon,
    text: `${t.title} – ponuja ${memberById(familyOcc[t.id].offer?.byId)?.name}`,
    go: () => setTab('druzina')
  })), ...care.map(t => ({
    key: `c-${t.id}`,
    icon: HandHeartIcon,
    text: `${t.title} – še nihče`,
    go: () => setTab('danes')
  })), ...rides.map(e => ({
    key: `r-${e.id}`,
    icon: CarIcon,
    text: `${e.title} (${formatShortDay(e.date)} ${e.start}) – kdo pelje?`,
    go: () => setTab('koledar')
  })), ...polls.map(p => ({
    key: `p-${p.id}`,
    icon: VoteIcon,
    text: `Glasovanje: ${p.title}`,
    go: () => setTab('druzina')
  }))];
  if (rows.length === 0) return <EmptyNote data-id="element-517" data-mp="3japooj8df7oj">Vse je dogovorjeno. Mir v hiši!</EmptyNote>;
  return <ul className="divide-y divide-line" data-id="element-518" data-mp="1dgzk9ni91y45">
      {rows.slice(0, 8).map(({
      key,
      icon: Icon,
      text,
      go
    }) => <li key={key} data-id="element-519" data-mp="1hitf3f5rk7we">
          <button type="button" onClick={go} className="flex w-full items-center gap-3 py-2.5 text-left text-sm font-semibold transition-colors duration-150 hover:text-accent-ink" data-id="element-520" data-mp="1hh08fzv5hnoe">
            <Icon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-521" data-mp="2lfvrat9xna4e" />
            <span className="min-w-0 flex-1" data-id="element-522" data-mp="2hea7enyzdvkp">{text}</span>
          </button>
        </li>)}
      {rows.length > 8 && <li className="pt-2 text-xs text-muted" data-id="element-523" data-mp="2cg8r2asxwacx">in še {rows.length - 8} …</li>}
    </ul>;
}